<template>
  <div v-if="featureEnabled">
    <slot name="featureEnabled"><slot></slot></slot>
  </div>
  <div v-else><slot name="featureDisabled"></slot></div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { getProperty } from "@/lib/helpers.js";

export default {
  props: {
    feature: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapState({
      tenant: "tenant",
      fetchingTenant: "fetchingTenant",
      featureEnabled({ tenant }) {
        if (!getProperty(tenant, "feature_flags") || !this.feature) {
          return false;
        }
        return tenant.feature_flags[this.feature];
      }
    })
  },
  created() {
    if (!this.tenant && !this.fetchingTenant) {
      this.fetchTenant();
    }
  },
  methods: {
    ...mapActions(["fetchTenant"])
  }
};
</script>

<style lang="scss" scoped></style>
